import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { forwardRef, useState } from 'react';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import useNearestSeparatorHidden from '../../hooks/useNearestSeparatorHidden.mjs';
import useOptionObserver from '../../hooks/useOptionCount.mjs';

const OPTION_COUNT_FALLBACK_STATE = -1;
const SelectGroup = forwardRef((props, ref) => {
  const [groupElement, setGroupElement] = useState(null);
  const optionCount = useOptionObserver(groupElement, {
    fallbackState: OPTION_COUNT_FALLBACK_STATE
  });
  const { title, ...groupProps } = props;
  const composedRef = useComposedRefs(ref, (node) => setGroupElement(node));
  const hasOptionElements = optionCount !== 0;
  useNearestSeparatorHidden(groupElement);
  return /* @__PURE__ */ jsx(
    Legacy_Dropdown.Group,
    {
      ref: composedRef,
      title: hasOptionElements ? title : void 0,
      ...groupProps,
      hidden: !hasOptionElements
    }
  );
});

export { SelectGroup };
//# sourceMappingURL=Group.mjs.map
